import { emitOrderFulfill } from 'hooks/app-events/orderFulfillEventBus';
import { OrderFulfill } from '../../../pb/events/v1/order_fulfill_pb';

export const useHandleOrderFulfill = () => {
    const handleOrderFulfill = (event: OrderFulfill) => {
        emitOrderFulfill(event);
    };

    return { handleOrderFulfill };
};

export default useHandleOrderFulfill;
